import { InternalAxiosRequestConfig } from "axios";
import authManager from "../auth/AuthManager";
import localStorageUtil from "utility/localStorageUtil";

export const AccessTokenInterceptor = (
  config: InternalAxiosRequestConfig<any>
) => {
  const token = authManager.getAccessToken();
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

const AuthInterceptor = (error: any) => {
  const status = error.response?.status || 500;
  const originalRequest = window.location.pathname;

  const loginUrls = ["/login", "/register", "/signup"];
  
  if (status === 401 || status === 403) {
    const isAuthUrl = loginUrls.some((url) => originalRequest?.includes(url));
    if (!isAuthUrl) {
      console.error("Redirecting due to 401/403 - Token expired or unauthorized");
      // Clear the expired token
      localStorageUtil.removeItem("accessToken");
      // Redirect to login page (using hash routing)
      window.location.href = "#/login";
    }
  }

  return Promise.reject(error);
};

export default AuthInterceptor;
